import { APICONFIG } from '@config/api.config';
import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import {
	AllMeetingParticipantsParams,
	AllParticipantsObject,
} from '@components/todayMeetingDetails/components/attendedMembers';
import { useGetRxDb } from '@hooks/getRxdbData';
import { ProfileData } from '../profile';

export const useGetParticipantsQuery = (
	parameters: AllMeetingParticipantsParams
): IQueryResponse<Array<AllParticipantsObject>> => {
	const { result: profile } = useGetRxDb<ProfileData>('profile');

	const isProfileLoaded = profile && profile.length > 0;
	const userRole = isProfileLoaded ? profile[0]?.usertype_c : undefined;

	const fetchParticipantsList = async (): Promise<Array<AllParticipantsObject>> => {
		const baseUrl = userRole === 'RBDM' ? APICONFIG.MEETINGS_DETAILS_RBDM : APICONFIG.MEETINGS_DETAILS;

		const response = await APIService.getData<Array<AllParticipantsObject>>(
			`${baseUrl}/${parameters.id}/all-participants`,
			{
				...(parameters.attendance_c && {
					attendance_c: `${parameters.attendance_c}`,
				}),
				...(parameters.convert_lead_c && {
					convert_lead_c: `${parameters.convert_lead_c}`,
				}),
				...(parameters.invited_c && {
					invited_c: `${parameters.invited_c}`,
				}),
				...(parameters.non_invited_c && {
					non_invited_c: `${parameters.non_invited_c}`,
				}),
				...(parameters.pidilite_employ_c && {
					pidilite_employ_c: `${parameters.pidilite_employ_c}`,
				}),
			}
		);

		return response;
	};

	const isMdpMeeting = parameters.type === 'MDP';

	const { data, error, isLoading, isPending, refetch, isFetching } = useQuery({
		queryKey: ['Participants', { ...parameters }, userRole],
		queryFn: fetchParticipantsList,
		enabled: !isMdpMeeting && (parameters.enable ?? true) && !!parameters.id && isProfileLoaded,
		refetchOnWindowFocus: false,
		retry: false,
		refetchInterval: 120000,
	});

	return {
		data: isMdpMeeting ? [] : data,
		error,
		isLoading: isMdpMeeting ? false : isLoading,
		isPending: isMdpMeeting ? false : isPending,
		refetch,
		isFetching: isMdpMeeting ? false : isFetching,
	};
};
